import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Select,
  Button,
  DatePicker,
  Form,
  InputNumber,
  Card,
  Spin,
  Tooltip,
} from "antd";
import { useTranslation } from "react-i18next";
import { noWhitespace } from "../../../../../utils/rules";
import { notify } from "../../../../../redux/actions";
import aictia from "../../../../../const/api";
import moment from "moment";
import { connect } from "react-redux";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import {
  SearchOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from "primereact/floatlabel";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const { Option } = Select;


function Project(props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const mainUrl = "Project";
  const history = useHistory();
  const [fieldOfUse, setFieldOfUse] = useState([]);
  const [typeOfProject, setTypeOfProject] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categoriesType, setCategoriesType] = useState([]);
  const [subDisable, setSubDisable] = useState(true);
  const [typeDisable, setTypeDisable] = useState(true);
  const [spin, setSpin] = useState(false);
  const [editing, setEditing] = useState(null);
  const [field, setField] = useState([]);
  const [projectCate, setProjectCate] = useState([]);
  const [techArray, setTechArray] = useState([0]);
  const [isEnd, setIsEnd] = useState(false);
  const [searchTinCompany, setSearchTinCompany] = useState("");
  const [searchCompanyData, setSearchCompanyData] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  // props
  const { notify } = props;


  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch Field of Use
        const fieldRes = await aictia.get("UsageArea");
        setFieldOfUse(fieldRes.data);

        // Fetch Type of Project
        const typeRes = await aictia.get("TypeOfProject");
        setTypeOfProject(typeRes.data);

        // Fetch Categories
        const categoryRes = await aictia.get("TechnologyFilter/TechnologyFields");
        const fetchedCategories = categoryRes.data.technologyCagegory || [];
        setCategories(fetchedCategories);

        // If editing existing project
        if (props.id) {
          setEditing(true);
          if (props.view) {
            setDisable(true);
          }
          const projectRes = await aictia.get(`${mainUrl}/${props.id}`);
          const project = projectRes.data;

          form.setFieldsValue({
            ...project,
            startDate: project.startDate ? moment(project.startDate) : null,
            usageAreaId: project.projectUsageAreas.map(item => item.usageAreaId),
          });
          setField(project.projectUsageAreas);
          setSubDisable(false);
          setTypeDisable(false);
          setCompanyId(project.reyestrOfCompanyId);
          setProjectCate(project.projectCategories);

          const techArray1 = [];
          const subCategoriesModify = [];
          const categoriesTypeModify = [];

          if (project.projectCategories.length > 0 && fetchedCategories.length > 0) {
            project.projectCategories.forEach((item, index) => {
              techArray1.push(index);

              // Find matching category
              const matchedCategory = fetchedCategories.find(
                (cat) => cat.id === item.technologyCategoryId
              );

              if (matchedCategory) {
                const subCate = matchedCategory.technologySubCagegory || [];
                subCategoriesModify.push({ index, array: subCate });

                const matchedSub = subCate.find(
                  (sub) => sub.id === item.technologySubcategoryId
                );
                const type = matchedSub?.technologyType || [];

                categoriesTypeModify.push({ index, array: type });
              }
            });
          } else {
            techArray1.push(0);
            setSubDisable(true);
            setTypeDisable(true);
          }

          setSubCategories(subCategoriesModify);
          setCategoriesType(categoriesTypeModify);
          setTechArray(techArray1);
        }

      } catch (error) {
        console.error("Data fetching error:", error);
      }
    };

    fetchData();
  }, [t]);


  //subcate
  const getSubcategories = (value, index) => {
    let cate = subCategories;

    cate = cate.filter((elem) => elem.index !== index);

    const subCate = categories.find(
      (item) => item.id === value
    ).technologySubCagegory;
    setSubCategories([...cate, { index: index, array: subCate }]);

    setSubDisable(false);
    form.resetFields([["projectCategories", index, "technologySubcategoryId"]]);
    form.resetFields([["projectCategories", index, "technologyTypeId"]]);
  };

  //type
  const getCategoriesType = (value, index) => {
    let cateType = categoriesType;
    cateType = cateType.filter((item) => item.index !== index);
    const data = subCategories.find((item) => item.index === index).array;
    const type = data.find((item) => item.id === value).technologyType;

    setCategoriesType([...cateType, { index: index, array: type }]);

    setTypeDisable(false);
    form.resetFields([["projectCategories", index, "technologyTypeId"]]);
  };

  const checkTinCompany = async () => {
    setLoading(true);
    const searchTinCompany = form.getFieldValue("searchTinCompany");
    aictia.get(`Portfolio/FindReyestrOfCompany?keyword=${searchTinCompany}`).then((res) => {
      if (res.data.length == 1) {
        form.setFieldsValue({
          subjectName: res.data[0].name,
          searchTinCompany: res.data[0].tin
        })
        setSearchTinCompany(res.data[0].tin);
        setCompanyId(res.data[0].id);
        setShowSuggestions(false);
        setSearchCompanyData([]);
      }
      else if (res.data.length > 1) {
        setSearchCompanyData(res.data);
      }
      else {
        setSearchCompanyData([]);
        form.setFieldsValue({
          subjectName: "",
        })
        form.setFields([
          {
            name: 'searchTinCompany',
            errors: ['Bu VÖEN tapılmadı'],
          },
        ]);
        setCompanyId(null);
      }
    })
      .catch((err) => {
        setLoading(false);
        notify(err.response, false);
      }
      ).finally(() => {
        setLoading(false)
      });
  }

  const cancelEditing = () => {
    setSubDisable(true);
    setTypeDisable(true);
    setEditing(null);
    setTechArray([0]);
    form.resetFields();
    history.push("/portfolio");
  };
  const save = async (values) => {
    const data = {
      ...values,
      reyestrOfCompanyId: companyId,
      // projectCategories: values.projectCategories[0].technologyCategoryId ? values.projectCategories : [],
      projectCategories: values.projectCategories.filter(
        (project) => project?.technologyCategoryId),
      endDate: values.endDate ? moment(values.endDate).format("YYYY-MM-DD") : null,
      projectUsageAreas: values?.usageAreaId ? values?.usageAreaId?.map((item) => {
        return {
          usageAreaId: item,
        };
      }) : []
    };
    if (!editing) {
      await aictia
        .post(`${mainUrl}`, data)
        .then((res) => {
          notify("", true);
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    } else {
      const id = Number(props.id);
      //field
      const dataUsageAreaIds = data?.projectUsageAreas.map(
        (item) => item.usageAreaId
      );
      const updateFieldsIds = field.map((elem) => elem.usageAreaId);
      const updatedField = field.map((item) => {
        const isActive = dataUsageAreaIds.includes(item.usageAreaId);
        return { ...item, isActive };
      });
      data.projectUsageAreas.map((elem) => {
        elem.isActive = true;
      });
      data.projectUsageAreas = data?.projectUsageAreas.filter(
        (elem) => !updateFieldsIds.includes(elem.usageAreaId)
      );
      data.projectUsageAreas.push(...updatedField);
      const modifyData = values?.projectCategories.filter((item) => item !== undefined);
      const projectCategoryIds = modifyData.map((item) => item.id);
      const updatedProjectCate = projectCate.map((item) => {
        const isActive = projectCategoryIds.includes(item.id);
        return { ...item, isActive };
      });

      const filteredModifyData = modifyData.filter((elem) => {
        if (elem.technologyCategoryId === undefined) {
          return false; // undefined olanları çıxarırıq
        }
        elem.isActive = true;
        return true; // yalnız uyğun olanları saxlayırıq
      });

      filteredModifyData.push(
        ...updatedProjectCate.filter((elem) => elem.isActive === false && elem.technologyCategoryId),

      );
      data.projectCategories = filteredModifyData;

      await aictia
        .put(`${mainUrl}/${id}`, { ...data, id: id })
        .then((res) => {
          notify("", true);
          cancelEditing();
        })
        .catch((err) => {
          notify(err.response, false);
        });
    }
  };

  const handleDeleteRow = (element) => {

    if (techArray.length > 1) {
      setTechArray(techArray.filter((elem) => elem !== element));
      form.resetFields([
        ["projectCategories", element, "technologyCategoryId"],
      ]);
      form.resetFields([
        [["projectCategories", element, "technologySubcategoryId"]],
      ]);
      form.resetFields([[["projectCategories", element, "technologyTypeId"]]]);
    }
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      spin
    />
  );

  return (
    <div>
      <Form layout="vertical" onFinish={save} form={form}>
        <div className={`commontask taskkk` + (props.view ? " detail" : "")}>
          <Card>

            <Row gutter={[16, 32]}>
              {
                !props.id && !props.view &&
                <Col md={6} sm={12} xs={24}>
                  <FloatLabel>
                    {
                      <Form.Item
                        name="searchTinCompany"
                        validateTrigger="onChange"
                      >
                        <div className="searchInput" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

                          <InputText disabled={props.id ? true : false} size={"large"} className='w-full' id="searchTinCompany" value={searchTinCompany}

                            onChange={(e) => {
                              setSearchTinCompany(e.target.value);
                              form.setFieldsValue({ searchTinCompany: e.target.value });
                              setShowSuggestions(true);
                            }}
                          />
                          {
                            !props.view && !props.id && (loading ? <Spin indicator={antIcon} className="searchTin" /> : <SearchOutlined onClick={checkTinCompany}
                              className="searchTin" />)
                          }

                        </div>

                        {showSuggestions && searchCompanyData.length > 1 && (
                          <ul
                            style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              right: 0,
                              backgroundColor: 'white',
                              border: '1px solid #ccc',
                              zIndex: 999,
                              maxHeight: 200,
                              overflowY: 'auto',
                              margin: 0,
                              padding: 0,
                              listStyle: 'none'
                            }}
                          >
                            {searchCompanyData.map(item => (
                              <li
                                key={item.id}
                                style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                                onClick={() => {
                                  form.setFieldsValue({
                                    subjectName: item.name,
                                    searchTinCompany: item.tin
                                  });
                                  setCompanyId(item.id);
                                  setSearchTinCompany(item.tin);
                                  setShowSuggestions(false);
                                }}
                              >
                                {item.name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </Form.Item>
                    }
                    <label htmlFor="searchTinCompany">{t('search')}</label>
                  </FloatLabel>
                </Col>
              }
              {
                !props.id && !props.view &&
                <Col md={6} sm={12} xs={24}>
                  <FloatLabel>
                    <Form.Item

                      name="subjectName"
                      validateTrigger="onChange"
                      rules={[noWhitespace(t("inputError"))]}

                    >
                      <InputText size={"large"} className="w-full" id="subjectName" disabled={true} />
                    </Form.Item>
                    <label htmlFor="subjectName">{t("Subyektin  adı ")}<span style={{ color: 'red' }}>*</span></label>

                  </FloatLabel>

                </Col>
              }


              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item

                    name="projectName"
                    validateTrigger="onChange"
                    rules={[noWhitespace(t("inputError"))]}

                  >
                    <InputText size={"large"} className="w-full" id="projectName" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="projectName">{t("Layihənin  adı ")} <span style={{ color: 'red' }}>*</span></label>

                </FloatLabel>

              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="ownerName"
                    validateTrigger="onChange"

                  >
                    <InputText size={"large"} className="w-full" id="ownerName" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="ownerName">{t("Layihə sahibinin adı")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                {/* <div className="dh">
                {t("Başlama Tarixi")}
                <div className="flex gap-4">
                  <Switch
                    onChange={(checked) => setIsEnd(checked)}
                    className="ml-10"
                  />
                  <p>Bitmə tarixi</p>
                </div>
              </div> */}
                <FloatLabel>

                  <Form.Item name="startDate" validateTrigger="onChange">
                    <DatePicker placeholder={t("Tarixi seçin")} className="w-100" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="startDate">{t("Başlama tarixi")}</label>

                </FloatLabel>
              </Col>
              {/* {isEnd ? (
              <Col md={6} sm={12} xs={24}>
                <Form.Item
                  label={t("*")}
                  name="endDate"
                  validateTrigger="onChange"
                >
                  <DatePicker placeholder={t("Tarixi seçin")} className="w-100" />
                </Form.Item>
              </Col>
            ) : (
              " "
            )} */}

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>


                  <Form.Item
                    name="usageAreaId"
                    validateTrigger="onChange"
                  //   rules={[whiteSpace(t("inputError"))]}
                  >
                    <Select
                      id="usageAreaId"
                      mode="multiple"
                      maxTagCount={1}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      maxTagPlaceholder={(omittedValues) => (
                        <Tooltip title={omittedValues.map(i => i.label).join(", ")}>
                          <span>+{omittedValues.length}</span>
                        </Tooltip>)}
                      disabled={disable}
                    >
                      {fieldOfUse.map((p, index) => {
                        return (
                          <Option key={index} value={p.id}>
                            {p.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <label htmlFor="usageAreaId">{t("İstifadə sahəsi")}</label>
                </FloatLabel>

              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>


                  <Form.Item
                    name="typeOfProjectId"
                    validateTrigger="onChange"
                    rules={[noWhitespace(t("inputError"))]}

                  >
                    <Select id="typeOfProjectId" disabled={disable}>
                      {typeOfProject.map((p, index) => {
                        return (
                          <Option key={index} value={p.id}>
                            {p.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <label htmlFor="typeOfProjectId">{t("Layihənin növü")}<span style={{ color: 'red' }}> *</span></label>
                </FloatLabel>
              </Col>

              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <div className="form-lang">

                    <Form.Item
                      name="budget"
                      validateTrigger="onChange"
                    >
                      <InputNumber id="budget" defaultValue={0} className={"w-full" + (props.view ? " custom-input-readonly" : "")} size={"large"} readOnly={disable} />

                    </Form.Item>
                    <div className="input-lang">azn</div>
                  </div>
                  <label htmlFor="budget">{t("Büdcə")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>

                  <Form.Item
                    name="purpose"
                    validateTrigger="onChange"
                  >
                    <InputText size={"large"} className="w-full" id="purpose" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="purpose">{t("Layihənin məqsədi")}</label>
                </FloatLabel>
              </Col>
              <Col md={6} sm={12} xs={24}>
                <FloatLabel>
                  <Form.Item
                    name="webPageUrl"
                    validateTrigger="onChange"
                  >
                    <InputText size={"large"} className="w-full" id="webPageUrl" disabled={disable} />
                  </Form.Item>
                  <label htmlFor="webPageUrl">{t("Web səhifə")}</label>
                </FloatLabel>
              </Col>

              {techArray.map((elem, index) => (
                <Col className="flex  flex-align-center" key={index} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <div style={{ display: "none" }}>
                    <FloatLabel>

                      <Form.Item
                        name={["projectCategories", elem, "id"]}
                        validateTrigger="onChange"
                      >
                        <InputText size={"large"} className="w-full" id="id" />
                      </Form.Item>
                      <label htmlFor="id">{t("Texnologiyanın kateqoriyası")}</label>
                    </FloatLabel>
                  </div>
                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>
                      <Form.Item
                        name={["projectCategories", elem, "technologyCategoryId"]}
                        validateTrigger="onChange"
                      >
                        <Select onChange={(value) => getSubcategories(value, elem)} disabled={disable}>
                          {categories.map((p, index) => {
                            return (
                              <Option key={index} value={p.id}>
                                {p.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologyCategoryId">{t("Texnologiyanın kateqoriyası")}</label>
                    </FloatLabel>
                  </Col>

                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>
                      <Form.Item
                        name={[
                          "projectCategories",
                          elem,
                          "technologySubcategoryId",
                        ]}
                        validateTrigger="onChange"
                      >
                        <Select
                          onChange={(value) => getCategoriesType(value, elem)}
                          disabled={props.view || subDisable}
                        >
                          {subCategories?.map((item) => {
                            if (item.index === elem) {
                              return item.array.map((p, index) => {
                                return (
                                  <Option key={index} value={p.id}>
                                    {p.name}
                                  </Option>
                                );
                              });
                            }
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologySubcategoryId">{t("Alt kateqoriyası")}</label>
                    </FloatLabel>
                  </Col>
                  <Col md={6} sm={12} xs={24}>
                    <FloatLabel>
                      <Form.Item
                        name={["projectCategories", elem, "technologyTypeId"]}
                        validateTrigger="onChange"
                      >
                        <Select disabled={props.view || typeDisable}>
                          {categoriesType.map((item) => {
                            if (item.index === elem) {
                              return item.array.map((p, index) => {
                                return (
                                  <Option key={index} value={p.id}>
                                    {p.name}
                                  </Option>
                                );
                              });
                            }
                          })}
                        </Select>
                      </Form.Item>
                      <label htmlFor="technologyTypeId">{t("Növü")}</label>
                    </FloatLabel>
                  </Col>

                  {props.view ? "" :

                    <div>
                      <Button
                        onClick={() => setTechArray([...techArray, techArray[techArray.length - 1] + 1])}
                        className={"ml-15"}
                        type={"primary"}
                        shape={"circle"}
                        icon={<PlusOutlined />}
                      />
                      <Button
                        onClick={() => {
                          handleDeleteRow(elem);
                        }}
                        className={"ml-15"}
                        type={"primary"}
                        shape={"circle"}
                        icon={<MinusOutlined />}
                      />
                    </div>
                  }
                </Col>
              ))}
            </Row>
            {
              props.view ? "" :

                <div className="flex flex-end mb-20">
                  <Button onClick={cancelEditing}>{t("cancel")}</Button>

                  <Button type="primary" className="ml-10" htmlType="submit">
                    {t("save")}
                  </Button>
                </div>
            }
          </Card>
        </div>


      </Form >


    </div >
  );
}

export default connect(null, { notify })(Project);

